<ion-item class="side-menu-item" [routerAnimation]="'none'" [routerLink]="path" routerLinkActive="--is-active" [detail]="false">
  <div class="side-menu-item__content">
    <ion-icon class="side-menu-item__content__icon" [name]="icon"></ion-icon>
    <div class="side-menu-item__content__text">
      <div class="side-menu-item__content__text__button" [innerHTML]="text"></div>
    </div>
  </div>
</ion-item>
